import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'
import { VODVideo } from '../../interfaces/vod'
import { VODService } from '../../services/vod.service'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-vod-grid',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './vod-grid.component.html',
  styleUrls: ['./vod-grid.component.scss'],
})
export class VODGridComponent extends BaseWidgetComponent implements OnInit, AfterViewInit {
  vods!: VODVideo[]
  selectedVOD?: VODVideo

  @ViewChild('container') container!: ElementRef

  constructor(private vodService: VODService) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()

    this.vods = this.vodService.vods
  }

  override applyStyles(): void {
    super.applyStyles()
  }

  ngAfterViewInit(): void {
    const vodCardStyle: Record<string, string | number> = {}

    // Apply 2:3 to card elements
    const width = this.container.nativeElement.clientWidth
    const itemWidth = width / 4
    const itemHeight = itemWidth * 1.5
    vodCardStyle['width'] = `${itemWidth}px`
    vodCardStyle['height'] = `${itemHeight}px`

    this.setRule('.vod-card', vodCardStyle)
    this.renderRules()
  }

  focusVOD(vod: VODVideo): void {
    this.selectedVOD = vod
    this.pageService.updateSubject(PAGE_KEY.SELECTED_VOD, this.selectedVOD)
  }

  openVOD(vod: VODVideo): void {
    this.vodService.openVOD(vod)
  }
}
